import theme from '../themes/default'
import {
  XS_PHONE,
  XXS_PHONE,
  XXXS_PHONE,
} from '../../../constants/mediaQuery'

const screenHeight = window.innerHeight

export default {
  wrap: {
    '& .am-activity-indicator': {
      background: '#fff',
      position: 'absolute',
      padding: '8px 5px',
      borderRadius: '5px',
      width: '42px',
      margin: '20% auto 0',
      left: '0',
      right: '0',
      'text-align': 'center',
    },
  },
  'slide-block-wrap': {
    width: 'initial',
    height: 'initial',
    color: '#614D4A',
  },
  'slide-block-active': {
    color: '#4a8ca1',
    'box-shadow': 'inset 0 -4px 0 #4a8ca1',
  },
  'slide-block': {
    height: '70px',
    '& > div': {
      // 'display': 'flex',
      // 'height': '100%',
      // 'align-items': 'center',
      padding: '8px 15px 0 20px',
    },
  },
  'swiper-container': {
    width: '100%',
    height: '70px',
    position: 'relative',
    overflow: 'hidden',
    'list-style': 'none',
    padding: 0,
    'z-index': 1,
  },
  list: {
    position: 'relative',
    '& ul': {
      margin: '0',
      padding: '0',
      '& li': {
        color: '#614D4A',
        'list-style-type': 'none',
        display: 'inline-block',
        position: 'relative',
        'text-align': 'right',
        'vertical-align': 'middle',
        '&:last-child': {
          'padding-left': '8px',
        },
      },
    },
    'margin-bottom': '15px',
    'margin-top': '15px',
    background: '#fff',
    color: '#614D4A',
    'min-height': '73px',
    // borderRadius: '5px',
    'box-shadow': '0 4px 8px 0 #CBC8C2',
    'margin-left': '15px',
    'margin-right': '15px',
    '& .am-icon': {
      'margin-top': '0px',
    },
    '& .am-stepper': {
      height: '69px',
    },
    '& .am-stepper-handler': {
      top: '22px',
      overflow: 'initial !important',
    },
    '& .am-stepper-input-wrap': {
      height: '68px',
      'line-height': '75px',
    },
  },

  //! waiter 的 flex item?
  'waiter-list': {
    'flex-wrap': 'wrap',
    width: 'calc(100%/3)',
    display: 'inline-block',
    margin: '0px',
    'min-height': '120px',
  },
  'sold-out-soon': {
    color: '#e31f28',
  },
  'pl-2': {
    'padding-left': '8px',
  },
  'list-background-image': {
    '&:after': {
      content: '""',
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      'background-image': 'linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, rgba(255,255,255,0.72) 38%, #FFFFFF 92%)',
      opacity: '1',
    },
  },
  'mobile-list-background-image': {
    '&:after': {
      content: '""',
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      opacity: '1',
    },
  },
  'list-left': {
    padding: '0 0 0 16px',
    'z-index': '1',
    'margin-left': '0 !important',
    '& li': {
      'margin-right': '5px',
    },
  },
  'list-left-wrap': {
    margin: '15px 0 15px 0',
  },
  'list-item-description': {
    'margin-top': '6px',
    'font-size': '12px',
    color: '#A59996',
    'font-weight': 'normal',
    '& .LinesEllipsis': {
      margin: '0',
    },
  },
  'list-item-name': {
    'font-weight': 'bold',
    'font-size': '14px',
  },
  'list-price-discount': {
    // 'width': '47% !important'
  },
  'list-right': {
    'margin-left': '0px !important',
    'z-index': '1',
    flex: '0.75 !important',
    'padding-top': '0px',
    'padding-right': '5px',
    'text-align': 'left',
    '& .am-list-body': {
      '&:before': {
        'background-color': 'transparent',
      },
      '&:after': {
        'background-color': 'transparent',
      },
    },
    '& .am-list-content': {
      flex: '0.7 !important',
    },
    '& .am-list-extra': {
      'flex-basis': 'auto',
    },
    '& .am-stepper-handler': {
      width: '25px',
      height: '25px',
      'line-height': '25px',
    },
    '& .am-stepper-handler-up, .am-stepper-handler-down': {
      borderRadius: '50%',
      border: '2px solid #4A8CA1',
      '& .am-icon': {
        color: '#4A8CA1',
      },
    },
    '& .am-stepper-input-wrap': {
      '& .am-stepper-input': {
        'margin-bottom': '6px',
      },
    },
  },
  'list-price-discount-wrap': {

  },
  'list-price-wrap': {
    position: 'absolute',
    top: '-16px',
    left: '-5px',
  },
  'list-price': {
    // 'width': '36%',
    'margin-right': '0px',
  },
  'list-price-prefix': {
    'font-size': '12px',
    'margin-left': '4px',
    'margin-right': '1px',
    display: 'inline-block',
    'vertical-align': 'middle',
    height: '13px',
    'line-height': '13px',
  },
  'list-price-amount': {
    'font-size': '20px',
    'font-weight': 'bold',
    'letter-spacing': '-2px',
    display: 'inline-block',
    'vertical-align': 'middle',
  },
  'list-price-undetermined': {
    'font-size': '20px',
    'font-weight': 'bold',
    'letter-spacing': '-2px',
    display: 'inline-block',
    color: '#C54545',
  },
  'list-price-discount-amount': {
    'font-size': '14px',
    color: '#555555',
    'font-weight': 'bold',
    'text-decoration': 'line-through',
    '& svg': {
      'font-size': '12px',
    },
  },
  'list-promo-tag': {
    width: '60px',
    color: '#fff',
    height: '14px',
    background: '#C54545',
    'letter-spacing': '4px',
    'text-align': 'center',
    position: 'absolute',
    'z-index': '1',
    top: '0',
    'border-top-right-radius': '12px',
    'border-bottom-right-radius': '14px',
    'padding-top': '3px',
    'padding-bottom': '2px',
    'font-size': '12px',
  },
  'list-stock-alert-tag': {
    width: '60px',
    right: '0',
    color: '#fff',
    height: '14px',
    background: '#C54545',
    'text-align': 'center',
    position: 'absolute',
    'z-index': '1',
    top: '0',
    'padding-top': '3px',
    'padding-bottom': '2px',
    'font-size': '12px',
  },
  'list-all': {
    padding: '0 20px',
  },
  'grid-container': {
    'padding-bottom': '8px',
  },
  'list-description-wrap': {
    background: '#fff',
    color: '#614D4A',
    'min-height': '53px',
    borderRadius: '5px',
    'box-shadow': '0 4px 8px 0 #CBC8C2',
  },
  'list-description': {
    padding: '0 16px',
    'z-index': '1',
    'margin-left': '0 !important',
  },
  'list-set': {
    'min-height': '53px',
    borderRadius: '0',
  },

  // bottomsheet
  'bottom-sheet-option-list': {
    padding: '0',
    color: '#614D4A',
    'font-weight': 'bold',
    'font-size': '16px',
  },
  'activity-indicatior-wrap': {
    height: '100%',
    'text-align': 'center',
    'padding-top': '28%',
    '& span': {
      margin: '0 auto',
    },
  },
  'simulate-bottom-sheet-overlay': {
    height: '140px',
    position: 'relative',
  },
  'previous-arrow-image': {
    width: '30px',
    position: 'absolute',
    bottom: '0',
    left: '0',
    padding: '20px',
  },
  'bottom-sheet-container': {
    background: '#fff',
    'padding-top': '35px',
    height: window.innerHeight - 120 + 'px',
    'text-align': 'left',
    '& .scrollbar-track-y': {
      right: '-10px',
    },
    '& .scroll-content': {
      'padding-bottom': '180px',
    },
  },
  'waiter-bottom-sheet-container': {
    background: '#fff',
    height: window.innerHeight,
    'text-align': 'left',
    '& .scrollbar-track-y': {
      right: '-10px',
    },
    '& .scroll-content': {
      'padding-bottom': '180px',
    },
  },
  'bottom-sheet-title': {
    background: '#fff',
    'padding-bottom': '10px',
  },
  'title-left': {
    position: 'relative',
    color: '#614D4A',
    'font-weight': 'bold',
    'font-size': '18px',
    padding: '5px 0 5px 20px',
  },
  'title-left-background': {
    width: '40px',
    height: '10px',
    position: 'absolute',
    top: '22px',
    left: '0',
    background: '#ffe394',
    'border-top-right-radius': '15px',
    'border-bottom-right-radius': '15px',
  },
  'waiter-title-left-background': {
    width: '40px',
    height: '10px',
    position: 'absolute',
    top: '104px',
    left: '0',
    background: '#ffe394',
    'border-top-right-radius': '15px',
    'border-bottom-right-radius': '15px',
  },
  'title-left-text': {

  },
  'title-right': {
    color: '#614D4A',
    height: '27px',
    padding: '10px 15px 5px 20px',
    'font-weight': 'bold',
    'text-align': 'right',
  },
  'title-right-price-prefix': {
    'margin-right': '3px',
    'vertical-align': 'middle',
    display: 'inline-block',
    height: '22px',
    'font-size': '13px',
  },
  'title-right-price': {
    'font-size': '20px !important',
    color: '#b30606 !important',
    display: 'inline-block',
  },
  'bottom-sheet-content': {
    padding: '15px',
    '& .am-checkbox-inner': {
      borderRadius: '0',
    },
  },
  'bottom-button-container': {
    padding: '15px',
    background: '#fff',
  },
  'bottom-button': {
    display: 'flex',
    flexDirection: 'row',
    border: '2px solid #D5AD40',
    borderRadius: '5px',
  },
  'back-button': {
    width: '20%',
    background: '#fff',
    color: '#D5AD40',
    'font-size': '16px !important',
  },
  'confirm-button': {
    width: '80%',
    '& .am-button': {
      background: '#D5AD40',
      color: '#fff',
      'font-size': '16px !important',
      borderRadius: '0px',
      '&:before': {
        border: '0px !important',
      },
    },
  },
  'bottom-sheet-group': {
    'margin-bottom': '30px',
  },
  'bottom-sheet-group-title': {
    'margin-bottom': '5px',
    color: '#b30606',
    'font-size': '14px',
    'font-weight': 'bold',
    'line-height': 'initial',
    padding: '0px 10px',
  },
  'bottom-sheet-group-title-button': {
    background: '#f2f6f9',
    width: '100%',
    height: 50,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 0,
    justifyContent: 'space-between',
    paddingRight: 10,
  },
  'bottom-sheet-total-price-wrap': {
    flex: '0.4 !important',
  },
  'sold-out-text': {
    width: '80px',
    'text-align': 'center',
    color: 'red',
    'font-size': '16px',
  },
  // bottomsheet

  [`@media screen and (max-width: ${XS_PHONE}px)`]: {
    // 'list-price-amount': {
    //     'font-size': '18px'
    // },
    // 'list-price-discount-amount': {
    //     'font-size': '13px'
    // }
  },
  [`@media screen and (max-width: ${XXS_PHONE}px)`]: {
    'list-left': {
      flex: '0.75 !important',
    },
    // 'list-price': {
    //     'width': '37% !important'
    // },
    'list-left-discount': {
      flex: '0.75 !important',
    },
    // 'list-price-discount': {
    //     'width': '45% !important'
    // },
  },
  [`@media screen and (max-width: ${XXXS_PHONE}px)`]: {
    'list-left': {
      '& div': {
        'font-size': '12px',
      },
    },
    'list-price-amount': {
      'font-size': '18px',
    },
    'list-price-discount-amount': {
      'font-size': '12px',
    },
  },
  'step-item-overlay': {
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: 'rgba(255, 255, 255, .8)',
    'z-index': '99',
  },
  'step-item-name': {
    'margin-top': '3px',
    'margin-bottom': '10px',
  },
  'badge-wrap': {
    position: 'absolute',
    top: '2px',
    right: '5px',
    '& .am-badge-text': {
      'background-color': 'transparent',
      'min-width': '12px',
      height: '20px',
      'line-height': '21px',
    },
  },
  badge: {
    background: '#4a8ca1',
    borderRadius: '10px',
    color: '#fff',
  },
  'badge-disable': {
    background: '#cbc8c2',
    borderRadius: '10px',
    color: '#fff',
  },
  'item-option-disable-overlay': {
    background: 'rgba(255, 255, 255, .5)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    'z-index': '1',
    overflow: 'hidden',
  },
  'search-mode-container': {
    position: 'fixed',
    zIndex: 100,
    top: 0,
    bottom: 60,
    left: 0,
    right: 0,
    backgroundColor: '#f1f1f1f1',
    display: 'flex',
    flexDirection: 'column',
  },
  'search-button-container': {
    height: 47,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  'search-button': {
    padding: 8,
    marginRight: 15,
    fontSize: 24,
  },
  'search-bar-container': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '8px 0px',
    zIndex: 100,
  },
  'search-bar-input': {
    width: '100%',
    padding: '8px 16px',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ccc',
    height: 18,
    marginLeft: 8,
  },
  'search-bar-icon-container': {
    height: 16,
    width: 79,
    padding: 9,
    backgroundColor: '#fff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeft: 0,
    borderColor: '#ccc',
    marginRight: 8,
    textAlign: 'center',
  },
  'waiter-stepper-items-container': {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/CategoryDetailList.js